import React from 'react';
import ListView from './ListView';
export default function Workspaces(){
  return <ListView icon="workspaces" title="Workspaces" subtitle="A customer's teams or projects — each maps to its own Plane project." path="/workspaces" columns={["id","customer_id","external_id","name"]} mapRow={r=>r} queryParam="name"/>;
}
